import { helper } from '@ember/component/helper';

const formatter = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
});
const quotient = 100;

export default helper(function euro(positional, named) {
  const [value] = positional;
  if (value === undefined || value === null) {
    return '';
  }
  return formatter.format((value as number) / quotient);
});

export function reverseEuro(value /*, named*/) {
  const sizeNum = parseFloat(value.replace(',', '.'));
  if (isNaN(sizeNum)) {
    return null;
  }
  return Math.round(sizeNum * quotient);
}
